/** The game's key bindings, kept free of rendering imports so the boot screens can list them too. */

/**
 * Configure Controls lists these bindings (label = string-table key). Modules that add hotkeys
 * register them here so the page stays complete.
 */
export const CONTROL_BINDINGS: { label: string; keys: string }[] = [
  { label: 'CfgCharacter', keys: 'C, A' },
  { label: 'CfgInventory', keys: 'I, B' },
  { label: 'CfgSkillTree', keys: 'T' },
  { label: 'Cfghireling', keys: 'O' },
  { label: 'CfgRunLock', keys: 'R' },
  { label: 'CfgShowItems', keys: 'Alt' },
  { label: 'CfgChat', keys: 'Enter' },
  { label: 'CfgBelt1', keys: '1' },
  { label: 'CfgBelt2', keys: '2' },
  { label: 'CfgBelt3', keys: '3' },
  { label: 'CfgBelt4', keys: '4' },
  { label: 'CfgSkill1', keys: 'F1' },
  { label: 'CfgSkill2', keys: 'F2' },
  { label: 'CfgSkill3', keys: 'F3' },
  { label: 'CfgSkill4', keys: 'F4' },
  { label: 'CfgSkill5', keys: 'F5' },
  { label: 'CfgSkill6', keys: 'F6' },
  { label: 'CfgSkill7', keys: 'F7' },
  { label: 'CfgSkill8', keys: 'F8' },
  { label: 'Cfgskillup', keys: 'Mouse Wheel Up' },
  { label: 'Cfgskilldown', keys: 'Mouse Wheel Down' },
  { label: 'CfgParty', keys: 'P' },
  { label: 'CfgMessageLog', keys: 'M' },
  { label: 'CfgQuestLog', keys: 'Q' },
  { label: 'CfgHelp', keys: 'H' },
  { label: 'CfgAutoMap', keys: 'Tab' },
  { label: 'CfgToggleminimap', keys: 'V' },
  { label: 'CfgAutoMapFade', keys: 'F10' },
  { label: 'CfgAutoMapParty', keys: 'F11' },
  { label: 'CfgAutoMapNames', keys: 'F12' },
  { label: 'CfgTogglePortraits', keys: 'Z' },
];
